export const preloadImage = src => {
  if (document.querySelector(`link[href="${src}"]`)) return;

  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = src;
  document.head.appendChild(link);
};

export const preloadImages = src => {
  src.forEach(preloadImage);
};

export const getImageInfo = async url =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
      const { width, height } = image;
      resolve({ width, height, ratio: width / height, image });
    };
    image.onerror = reject;
    image.src = url;
  });

export default {};
